import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\InvoicingCategory\CreateInvoicingCategoryController::__invoke
* @see app/Http/Controllers/InvoicingCategory/CreateInvoicingCategoryController.php
* @route '/api/invoicing-category'
*/
const CreateInvoicingCategoryController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateInvoicingCategoryController.url(options),
    method: 'post',
})

CreateInvoicingCategoryController.definition = {
    methods: ["post"],
    url: '/api/invoicing-category',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\InvoicingCategory\CreateInvoicingCategoryController::__invoke
* @see app/Http/Controllers/InvoicingCategory/CreateInvoicingCategoryController.php
* @route '/api/invoicing-category'
*/
CreateInvoicingCategoryController.url = (options?: RouteQueryOptions) => {
    return CreateInvoicingCategoryController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoicingCategory\CreateInvoicingCategoryController::__invoke
* @see app/Http/Controllers/InvoicingCategory/CreateInvoicingCategoryController.php
* @route '/api/invoicing-category'
*/
CreateInvoicingCategoryController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateInvoicingCategoryController.url(options),
    method: 'post',
})

export default CreateInvoicingCategoryController